import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import type {
	AemuiContentFragment,
	AemuiLeadFormConfig,
	AemuiWaitlistInterest,
	AemuiWaitlistItem
} from 'Types/aemui/content-fragments/contentFragment';
import type { FiltersConfigResponse, Location } from 'Types/aemui/find-a-location/findaLocation';
import type { AemuiClubState } from 'Types/aemui/wellness-form/aemuiWellnessForm';

export const aemServletServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: '/bin/lt'
});

class AemServletService {
	axiosInstance: AxiosInstance = aemServletServiceAxiosInstance;

	getClubsByState(): AxiosPromise<AemuiClubState[]> {
		return this.axiosInstance.get('/clubListByState');
	}

	getClassInterests(clubId: number): AxiosPromise<AemuiContentFragment<AemuiWaitlistInterest>> {
		return this.axiosInstance.get(`/cfExporter.json/${clubId}?cfp=/lt/life-time/class-interests`);
	}

	getLeadFormConfig(clubId: number): AxiosPromise<AemuiContentFragment<AemuiLeadFormConfig>> {
		return this.axiosInstance.get(`/cfExporter.json/${clubId}?cfp=/lt/life-time/lead-form-config`);
	}

	getLocatorFilterConfig(): AxiosPromise<FiltersConfigResponse> {
		return this.axiosInstance.get('/locator-filter-config');
	}

	getNearestClubs(limit = 300, distance = 150000): AxiosPromise<Location[]> {
		return this.axiosInstance.get('/nearestClubServlet.d360.locator.json', {
			params: { limit, distance }
		});
	}

	getLifeClinicLocations(limit = 300, distance = 150000): AxiosPromise<Location[]> {
		return this.axiosInstance.get('/nearestClubServlet.lifeclinic.locator.json', {
			params: { limit, distance }
		});
	}

	getWorkLocations(limit = 300, distance = 150000): AxiosPromise<Location[]> {
		return this.axiosInstance.get('/nearestClubServlet.work.locator.json', {
			params: { limit, distance }
		});
	}

	getWaitlistItems(clubId: number): AxiosPromise<AemuiContentFragment<AemuiWaitlistItem>> {
		return this.axiosInstance.get(
			`/cfExporter.json/${clubId}?cfp=/lt/life-time/waitlist&prc=waitlist`
		);
	}

	getWaitlistInterests(clubId: number): AxiosPromise<AemuiContentFragment<AemuiWaitlistInterest>> {
		return this.axiosInstance.get(
			`/cfExporter.json/${clubId}?cfp=/lt/life-time/waitlist-interests`
		);
	}
}

export const aemServletService = new AemServletService();
